// Who the energy bill is in the name of. The aggregate-backed shared projection is present for
// LIHEAP/SHEAP-only files; PSE keeps its legacy bill projection as the fallback. The editor and
// the card that shows these saved facts must read the same precedence.
import type { BenefitDetailDto } from "./benefit-types"

export type BillIdentity = {
  appearsAs: number | null
  lastName: string
  firstName: string
  middleName: string
  dateOfBirth: string | null
  is18OrEmancipated: boolean
  isStillLivingAtResidence: boolean
  isSpouseOfApplicant: boolean
  isDeceasedSpouseOfApplicant: boolean
}

export function billIdentityOf(benefit: BenefitDetailDto): BillIdentity | null {
  const appearsAs = benefit.energyBillInformation?.applicantAppearsAs
    ?? benefit.pseBenefitDetails?.applicantsAppearanceOnPseBill ?? null
  const shared = benefit.energyBillInformation
  if (shared) return { ...shared, appearsAs }
  const bill = benefit.pseBenefitDetails?.pseBillInformation
  if (!bill) return null
  return {
    appearsAs,
    lastName: bill.lastName,
    firstName: bill.firstName,
    middleName: bill.middleName,
    dateOfBirth: bill.dateOfBirth,
    is18OrEmancipated: bill.is18OrEmancipated,
    isStillLivingAtResidence: bill.isStillLivingAtResidence,
    isSpouseOfApplicant: bill.isSpouseOfTheApplicant,
    isDeceasedSpouseOfApplicant: bill.isDeceasedSpouseOfTheApplicant,
  }
}
